export const RemoveProjectFileMutation = `
mutation RemoveFileFromProject($mediaitemids:[Int]!,$postid:Int!){
  RemoveCourseFile(mediaitemids:$mediaitemids,postid:$postid){
    success
  }
}`;
